import { render, staticRenderFns } from "./FilterSlider.vue?vue&type=template&id=d97700c8&scoped=true&"
import script from "./FilterSlider.vue?vue&type=script&lang=js&"
export * from "./FilterSlider.vue?vue&type=script&lang=js&"
import style0 from "./FilterSlider.vue?vue&type=style&index=0&id=d97700c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97700c8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default})
